/**
 * Unions API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Редактировать контакт комитета.
 */
export interface EditCommitteeContact { 
    /**
     * Тип контакта
     */
    contactTypeId?: number;
    /**
     * Контакт для связи.
     */
    contact?: string;
    /**
     * Описание.
     */
    description?: string;
    /**
     * Приоритет.
     */
    isPriority?: boolean;
    /**
     * Сортировка.
     */
    sortOrder?: number;
    isRequired?: boolean;
    /**
     * ID контакта.
     */
    committeeId?: string;
    customListValueId?: string;
    customListId?: string;
    /**
     * ID контакта. Возможен NULL, потому что в PATCH комитета могут передаваться и новые контакты.
     */
    id?: string;
}

